/** @type {string} */
const collapseString = "collapse";
export default collapseString;
